export default function MidBar({ midbar, activeSite, banner }) {
  return (
    <div
      className={`mid transition-opacity duration-500 ease-in-out ${
        midbar ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="currently-playing rounded-3xl">
        <div className="kaszi">
          <img
            src={
              activeSite
                ? activeSite.logo
                : "https://cdn.streamelements.com/uploads/01k842ysya0r08qqp7x8z0kzet.png"
            }
            alt="Do not gamble! Never chase your losses."
          />
          <p className="szoveg">
            {activeSite
              ? activeSite.desc
              : "Do not gamble! Never chase your losses."}
          </p>
        </div>
      </div>
      <div className="announcements rounded-3xl">
        <img src="/announcements/2.png" alt="ann" />
      </div>
      <div className="giveaway rounded-3xl">
        <p className="leiras">{banner}</p>
        <img src="/hadesz.svg" alt="" />
      </div>
      <div className="discord rounded-3xl">
        <img src="/discord.svg" alt="Discord icons" width="100%" />
      </div>
    </div>
  );
}
